import { defineCatalogue } from '../../../i18n';

export const recordCatalogue = defineCatalogue(
  {
    'page.eyebrow': 'Campanha',
    'section.details': 'Dados da campanha',
    'section.identification': 'Identificação',
    'section.period': 'Período',

    'name.label': 'Nome da campanha',
    'description.label': 'Do que a campanha trata',
    'timezone.label': 'Fuso',
    'activeFrom.label': 'Começa em',
    'activeTo.label': 'Termina em',
    'field.empty': 'Não definido',
    'date.empty': 'Sem data',

    'state.label': 'Estado',
    'state.active': 'Ativa',
    'state.paused': 'Pausada',
    'state.archived': 'Encerrada',

    'candidate.title': 'Candidatura',
    'candidate.tseBadge': 'do cadastro do TSE',
    // `.term` is this screen's own read-only row (`DefinitionRows`); `.label` is
    // `TseCandidatePicker`'s manual-entry input label. Gender-neutral: the candidature's own
    // gender is not a field this screen reads, so its label never presumes one.
    'candidate.name.term': 'Nome',
    'candidate.name.label': 'Nome do candidato',
    'candidate.office.label': 'Cargo',
    'candidate.number.label': 'Número',
    'candidate.state.label': 'Estado',
    'candidate.party.label': 'Partido',
    'candidate.election.label': 'Eleição',
    'candidate.coalition.label': 'Coligação',
    'candidate.empty': 'Nenhuma candidatura definida',
    'candidate.scope.term': 'Abrangência',

    'relatedPosts.title': 'Publicações relacionadas',
    'relatedPosts.window': '{related} de {total} publicações coletadas nos últimos 7 dias.',
    'relatedPosts.review': 'Revisar publicações fora do grupo',

    'outOfGroup.back': 'Voltar',
    'outOfGroup.title': 'Publicações fora do grupo',
    'outOfGroup.empty.title': 'Nenhuma publicação fora do grupo no período.',
    'outOfGroup.post.noCaption': 'Sem legenda',
    'outOfGroup.post.deleted': 'Excluída',
    'outOfGroup.post.open': 'Abrir publicação',
    'outOfGroup.loadMore': 'Carregar mais',

    'presence.title': 'Contas e links',
    'presence.empty': 'Nenhum perfil ou site adicionado.',
    'presence.platform.instagram': 'Instagram',
    'presence.platform.tiktok': 'TikTok',
    'presence.subtitle.platform': '{platform} · perfil oficial',
    'presence.subtitle.site': 'Site da campanha',
    'presence.remove': 'Remover {address}',
    'presence.remove.confirm.title': 'Remover {address}?',
    'presence.remove.confirm.description':
      'A campanha para de mostrar este perfil ou site; isso não afeta nada já coletado.',
    'presence.remove.confirm.action': 'Remover',
    'presence.add.trigger': 'Adicionar perfil ou site',
    'presence.add.title': 'Adicionar perfil ou site',
    'presence.add.submit': 'Adicionar',
    'presence.add.kind.label': 'Tipo',
    'presence.add.kind.site': 'Site',
    'presence.add.address.handle': 'Perfil',
    'presence.add.address.handle.placeholder': 'usuario.oficial',
    'presence.add.address.site': 'Endereço do site',
    'presence.add.address.site.placeholder': 'https://minhacampanha.com.br',

    'saveBar.label': 'Alterações não salvas',
    'saveBar.changed.one': '{count} alteração não salva',
    'saveBar.changed.other': '{count} alterações não salvas',
    'saveBar.save': 'Salvar',
    'saveBar.discard': 'Descartar',

    'endCampaign.title': 'Pausar a coleta',
    'endCampaign.paused.description': 'A coleta está pausada. A campanha ainda ocupa uma vaga.',
    'endCampaign.archived.description': 'A campanha está arquivada e não pode ser reaberta.',
    'endCampaign.pause': 'Pausar coleta',
    'endCampaign.resume': 'Retomar coleta',
    'endCampaign.archive.trigger': 'Arquivar campanha',
    'endCampaign.archive.title': 'Arquivar esta campanha?',
    'endCampaign.archive.description':
      'Isso não pode ser desfeito. A campanha libera sua vaga e continua visível, mas não pode mais ser editada.',
    'endCampaign.archive.confirm': 'Arquivar',

    'retention.title': 'Retenção de dados',
    'retention.label': 'Retenção após o fim da campanha',
    'retention.inherit': 'Herdar da organização ({period})',
    'retention.custom': 'Prazo próprio',
    'retention.period.label': 'Prazo',
    'retention.description':
      'Depois que a campanha termina, na data de término ou ao ser arquivada, os dados coletados para ela ficam guardados por este prazo e depois são apagados. Enquanto ela está ativa, nada é apagado. Mínimo de 30 dias.',
    'retention.unrelated.label': 'Retenção de publicações não relacionadas',
    'retention.unrelated.description':
      'Publicações e stories das contas monitoradas que esta campanha não considera relacionados são apagados depois deste prazo contado da coleta, se nenhuma outra campanha ativa os considerar relacionados. Mínimo de 6 horas.',
    'retention.purgeAt': 'Dados apagados em',

    'candidate.more': 'Mais ações da candidatura',
    'candidate.remove': 'Remover candidato',
    'candidate.photo': 'Foto de {name} no cadastro do TSE',

    'relatedPosts.short': 'relacionadas',

    'status.label': 'Coleta',
    'status.collecting': 'Coletando',
    'status.paused': 'Pausada',
    'status.pausedSince': 'Pausada desde {when}',
    'status.archived': 'Encerrada',
    'status.switch': 'Coleta ativa',
    'status.more': 'Mais ações da campanha',
    'status.pause.title': 'Pausar a coleta?',
    'status.pause.description':
      'Enquanto pausada, nenhuma conta desta campanha é coletada e nenhum crédito é gasto com ela. O que já foi coletado continua disponível, e a campanha continua ocupando uma vaga.',
    'status.pause.confirm': 'Pausar coleta',
    'status.resume.title': 'Retomar a coleta?',
    'status.resume.description':
      'A coleta volta a seguir a agenda das contas monitoradas e a gastar créditos. O período em que ficou pausada não é recuperado.',
    'status.resume.confirm': 'Retomar coleta',

    'alliances.title': 'Aliados e adversários',
    'alliances.description':
      'Toda análise de publicações e comentários lê esta lista: apoio a um aliado conta como apoio à campanha.',
    'alliances.heading': '{label} ({count})',
    'alliances.ally': 'Aliados',
    'alliances.opponent': 'Adversários',
    'alliances.add.ally': 'Adicionar aliado',
    'alliances.add.opponent': 'Adicionar adversário',
    'alliances.search.label': 'Buscar candidato, partido ou entidade',
    'alliances.search.placeholder': 'Nome, número ou partido',
    'alliances.search.hint': 'Digite ao menos 2 caracteres.',
    'alliances.search.loading': 'Buscando…',
    'alliances.search.empty': 'Nada encontrado.',
    'alliances.group.candidate': 'Candidaturas do TSE',
    'alliances.group.party': 'Partidos',
    'alliances.group.entity': 'Entidades',
    'alliances.empty.ally': 'Nenhum aliado ainda.',
    'alliances.empty.opponent': 'Nenhum adversário ainda.',
    'alliances.remove': 'Remover {name}',
    'alliances.kind.party': 'Partido',
    'alliances.kind.organization': 'Organização',
    'alliances.kind.entity': 'Entidade',
    'alliances.number': 'nº {number}',
    'alliances.suggestions.title': 'Sugestões do cadastro do TSE',
    'alliances.suggestions.add': 'Adicionar as {count} sugestões',
    'alliances.suggestions.empty': 'O TSE não sugere ninguém para esta candidatura.',

    'presence.pending': 'Perfil ainda não coletado',
    'presence.followers': 'seguidores',
    'presence.following': 'seguindo',
    'presence.posts': 'publicações',
    'presence.verified': 'Conta verificada',
    'presence.private': 'Privada',
  },
  {
    'page.eyebrow': 'Campaign',
    'section.details': 'Campaign record',
    'section.identification': 'Identification',
    'section.period': 'Period',

    'name.label': 'Campaign name',
    'description.label': 'What the campaign is about',
    'timezone.label': 'Timezone',
    'activeFrom.label': 'Start',
    'activeTo.label': 'End',
    'field.empty': 'Not set',
    'date.empty': 'No date',

    'state.label': 'State',
    'state.active': 'Active',
    'state.paused': 'Paused',
    'state.archived': 'Archived',

    'candidate.title': 'Candidature',
    'candidate.tseBadge': 'from the TSE registry',
    'candidate.name.term': 'Name',
    'candidate.name.label': 'Candidate name',
    'candidate.office.label': 'Office',
    'candidate.number.label': 'Ballot number',
    'candidate.state.label': 'State',
    'candidate.party.label': 'Party',
    'candidate.election.label': 'Election',
    'candidate.coalition.label': 'Coalition',
    'candidate.empty': 'No candidature set',
    'candidate.scope.term': 'Scope',

    'relatedPosts.title': 'Related posts',
    'relatedPosts.window': '{related} of {total} posts collected in the last 7 days.',
    'relatedPosts.review': 'Review posts outside the group',

    'outOfGroup.back': 'Back',
    'outOfGroup.title': 'Posts outside the group',
    'outOfGroup.empty.title': 'No posts outside the group in this window.',
    'outOfGroup.post.noCaption': 'No caption',
    'outOfGroup.post.deleted': 'Deleted',
    'outOfGroup.post.open': 'Open post',
    'outOfGroup.loadMore': 'Load more',

    'presence.title': 'Accounts and links',
    'presence.empty': 'No profile or site added.',
    'presence.platform.instagram': 'Instagram',
    'presence.platform.tiktok': 'TikTok',
    'presence.subtitle.platform': '{platform} · official profile',
    'presence.subtitle.site': 'Campaign site',
    'presence.remove': 'Remove {address}',
    'presence.remove.confirm.title': 'Remove {address}?',
    'presence.remove.confirm.description':
      'The campaign stops showing this profile or site; it does not affect anything already collected.',
    'presence.remove.confirm.action': 'Remove',
    'presence.add.trigger': 'Add profile or site',
    'presence.add.title': 'Add profile or site',
    'presence.add.submit': 'Add',
    'presence.add.kind.label': 'Type',
    'presence.add.kind.site': 'Site',
    'presence.add.address.handle': 'Handle',
    'presence.add.address.handle.placeholder': 'official.handle',
    'presence.add.address.site': 'Site address',
    'presence.add.address.site.placeholder': 'https://mycampaign.example',

    'saveBar.label': 'Unsaved changes',
    'saveBar.changed.one': '{count} unsaved change',
    'saveBar.changed.other': '{count} unsaved changes',
    'saveBar.save': 'Save',
    'saveBar.discard': 'Discard',

    'endCampaign.title': 'Pause collection',
    'endCampaign.paused.description': 'Collection is paused. The campaign still occupies a slot.',
    'endCampaign.archived.description': 'The campaign is archived and cannot be reopened.',
    'endCampaign.pause': 'Pause collection',
    'endCampaign.resume': 'Resume collection',
    'endCampaign.archive.trigger': 'Archive campaign',
    'endCampaign.archive.title': 'Archive this campaign?',
    'endCampaign.archive.description':
      'This cannot be undone. The campaign releases its slot and stays visible, but can no longer be edited.',
    'endCampaign.archive.confirm': 'Archive',

    'retention.title': 'Data retention',
    'retention.label': 'Retention after the campaign ends',
    'retention.inherit': 'Inherit from the organisation ({period})',
    'retention.custom': 'Own period',
    'retention.period.label': 'Period',
    'retention.description':
      'Once the campaign ends, on its end date or when it is archived, the data collected for it is kept for this period and then deleted. Nothing is deleted while it is active. At least 30 days.',
    'retention.unrelated.label': 'Retention of unrelated posts',
    'retention.unrelated.description':
      'Posts and stories from tracked accounts that this campaign does not read as related are deleted this long after they were collected, unless another active campaign reads them as related. At least 6 hours.',
    'retention.purgeAt': 'Data deleted on',

    'candidate.more': 'More candidature actions',
    'candidate.remove': 'Remove candidate',
    'candidate.photo': "{name}'s photo in the TSE registry",

    'relatedPosts.short': 'related',

    'status.label': 'Collection',
    'status.collecting': 'Collecting',
    'status.paused': 'Paused',
    'status.pausedSince': 'Paused since {when}',
    'status.archived': 'Archived',
    'status.switch': 'Collection on',
    'status.more': 'More campaign actions',
    'status.pause.title': 'Pause collection?',
    'status.pause.description':
      'While paused, no account in this campaign is collected and no credit is spent on it. What was already collected stays available, and the campaign keeps its slot.',
    'status.pause.confirm': 'Pause collection',
    'status.resume.title': 'Resume collection?',
    'status.resume.description':
      "Collection follows the tracked accounts' schedule and spends credits again. The paused period is not recovered.",
    'status.resume.confirm': 'Resume collection',

    'alliances.title': 'Allies and adversaries',
    'alliances.description':
      'Every post and comment analysis reads this list: support for an ally counts as support for the campaign.',
    'alliances.heading': '{label} ({count})',
    'alliances.ally': 'Allies',
    'alliances.opponent': 'Adversaries',
    'alliances.add.ally': 'Add ally',
    'alliances.add.opponent': 'Add adversary',
    'alliances.search.label': 'Search a candidate, party or entity',
    'alliances.search.placeholder': 'Name, number or party',
    'alliances.search.hint': 'Type at least 2 characters.',
    'alliances.search.loading': 'Searching…',
    'alliances.search.empty': 'Nothing found.',
    'alliances.group.candidate': 'TSE candidatures',
    'alliances.group.party': 'Parties',
    'alliances.group.entity': 'Entities',
    'alliances.empty.ally': 'No allies yet.',
    'alliances.empty.opponent': 'No adversaries yet.',
    'alliances.remove': 'Remove {name}',
    'alliances.kind.party': 'Party',
    'alliances.kind.organization': 'Organisation',
    'alliances.kind.entity': 'Entity',
    'alliances.number': 'no. {number}',
    'alliances.suggestions.title': 'Suggested by the TSE registry',
    'alliances.suggestions.add': 'Add all {count} suggestions',
    'alliances.suggestions.empty': 'The TSE registry suggests no one for this candidature.',

    'presence.pending': 'Profile not collected yet',
    'presence.followers': 'followers',
    'presence.following': 'following',
    'presence.posts': 'posts',
    'presence.verified': 'Verified account',
    'presence.private': 'Private',
  },
);

export const rm = recordCatalogue.t;
export const rmPlural = recordCatalogue.plural;
